var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
export function getResources(technology) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = technology ? `?technology=${encodeURIComponent(technology)}` : '';
        return client.get(`/resources${params}`);
    });
}
export function getTechnologies() {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get('/resources/technologies');
    });
}
export function getResourceById(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/resources/${id}`);
    });
}
export function createResource(resourceData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post('/resources', resourceData);
    });
}
export function updateResource(id, resourceData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/resources/${id}`, resourceData);
    });
}
// Delete a resource (archive it)
export function deleteResource(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.delete(`/resources/${id}`);
    });
}
export function restoreResource(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/resources/${id}/restore`);
    });
}
export function deleteResourcePermanently(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.delete(`/resources/${id}/permanent`);
    });
}
